import {ServiceClass} from '@/decorators';
import {CreateEditEquipmentConnectorPinViewModel, EquipmentConnectorPinModel, UpdateConnectorPinSortOrderEquipmentCapModel} from '../models';
import {BaseApi} from './base.api';

@ServiceClass()
export class EquipmentConnectorPinsApi extends BaseApi {
    public getLocationConnectorPins(locationId: string, filter: any = {}) {
        return this.GET_RequestAsync<EquipmentConnectorPinModel[]>(
            `${this.ApiUrl}/locations/${locationId}/equipment-connector-pins?filter=${encodeURIComponent(JSON.stringify(filter))}`
        );
    }

    public getConnectorPinById(id: string) {
        return this.GET_RequestAsync<EquipmentConnectorPinModel>(`${this.ApiUrl}/equipment-connector-pins/${id}`);
    }

    public createEquipmentConnectorPin(locationId: string, data: CreateEditEquipmentConnectorPinViewModel) {
        return this.POST_RequestAsync<EquipmentConnectorPinModel>(`${this.ApiUrl}/locations/${locationId}/equipment-connector-pins`, data);
    }

    public createConnectorPinsMultiple(locationId: string, afterOrder: number, data: CreateEditEquipmentConnectorPinViewModel[]) {
        return this.POST_RequestAsync<EquipmentConnectorPinModel[]>(
            `${this.ApiUrl}/locations/${locationId}/equipment-connector-pins/multiple?afterOrder=${afterOrder}`,
            data
        );
    }

    public updateConnectorPin(locationId: string, pinId: string, data: CreateEditEquipmentConnectorPinViewModel) {
        delete data.id;
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/locations/${locationId}/equipment-connector-pins/${pinId}`, data);
    }

    public markConnectorPinActive(pinId: string) {
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/equipment-connector-pins/${pinId}/mark-active`, {});
    }

    public markConnectorPinInactive(pinId: string) {
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/equipment-connector-pins/${pinId}/mark-inactive`, {});
    }

    public deleteConnectorPin(id: string) {
        return this.DELETE_RequestAsync<void>(`${this.ApiUrl}/equipment-connector-pins/${id}`);
    }

    public updateSortOrder(locationId: string, data: UpdateConnectorPinSortOrderEquipmentCapModel) {
        return this.POST_RequestAsync<void>(`${this.ApiUrl}/locations/${locationId}/equipment-connector-pins/sort-order`, data);
    }
}
